import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import keychainInstructions from 'assets/images/keychain-instructions.png';
import { CheckIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ButtonType } from '../ui/Button';

const KeychainInstructions: React.FC = () => {
  const intl = useIntl();

  return (
    <div className="flex flex-col gap-10 mb-8 items-center w-full">
      <div className="text-s">
        <FormattedMessage
          id="keychainInstructionsModal.message"
          /* eslint-disable-next-line max-len */
          defaultMessage="Please remove all items other than your key, including the key ring, before placing it in the kiosk. Otherwise, it could damage your key or the kiosk."
        />
      </div>
      <div className="relative w-[385px] max-w-[85%] kioskPartteam:w-[512px]">
        <img
          alt={intl.formatMessage({ id: 'keychainInstructionsModal.alt', defaultMessage: 'Instructions for the key ring' })}
          src={keychainInstructions}
          className="w-full"
        />
        <div className="absolute top-0 left-[16%] w-1/6 aspect-square grid place-items-center bg-danger-default/20 rounded-full">
          <ExclamationTriangleIcon className="text-white rounded-full size-2/5 bg-danger-default !ring-8 ring-danger-default" />
        </div>
        <div className="absolute top-0 right-[16%] w-1/6 aspect-square grid place-items-center bg-success-default/20 rounded-full">
          <CheckIcon className="text-white rounded-full size-2/5 bg-success-default !ring-8 ring-success-default" />
        </div>
      </div>
    </div>
  );
};

export const KEYCHAIN_INSTRUCTIONS_STEP = {
  title: <FormattedMessage id="keychainInstructionsModal.title" defaultMessage="Warning" tagName="h2" />,
  content: <KeychainInstructions />,
  buttonType: ButtonType.TERTIARY,
  buttonText: <FormattedMessage id="keychainInstructionsModal.button" defaultMessage="I removed all items" />,
};

export default KeychainInstructions;
